import {all, call, fork, put, take, takeEvery} from "redux-saga/effects";
import {fetchStickySuccess} from '../actions/Notes';
import {database} from '../../firebase/firebase';
import { INITWEBSOCKET, NOTIFICATION_NEW } from '../../constants/ActionTypes';
import { eventChannel, END } from 'redux-saga';
import {fetchError} from "../actions/Common";

const initWebsocketRequest = (username) => {
  return eventChannel(emitter => {
    let wsUrl = 'wss://04sun5in2j.execute-api.ap-northeast-1.amazonaws.com/' + process.env.REACT_APP_STAGE;

    if (process.env.REACT_APP_STAGE == 'cn') {
      wsUrl = 'wss://c0r71gjxa4.execute-api.ap-northeast-1.amazonaws.com/prod';
    } else if (process.env.REACT_APP_STAGE == 'main') {
      wsUrl = 'wss://kqkhkqpbb2.execute-api.ap-northeast-1.amazonaws.com/' + process.env.REACT_APP_STAGE;
    }

    const ws = new WebSocket(wsUrl);
    ws.onopen = () => {
      console.log('initWebsocket','onOpen');
      ws.send('{"action":"notification","username":"' + username + '"}');
    }
    ws.onerror = (error) => {
      console.log('initWebsocket','onerror', error);

      // retry after 10 seconds
      initWebsocketCall(username);
    }
    ws.onmessage = (e) => {
      let msg = null
      try {
        msg = JSON.parse(e.data)
      } catch(e) {
        console.error(`Error parsing : ${e.data}`)
      }
      if (msg) {
        console.log('msg', msg)
        return emitter({ type: NOTIFICATION_NEW, payload: msg, email: username});
      }
    }
    // unsubscribe function
    return () => {
      console.log('Socket off')
    }
  });
}

function* initWebsocketCall({payload}) {
  const email = localStorage.getItem('bms-email');
  const channel = yield call(initWebsocketRequest, email);

  while (true) {
    const action = yield take(channel);
    yield put(action);
  }
}

export function* initWebsocket() {
  console.log('initWebsocket');
  yield takeEvery(INITWEBSOCKET, initWebsocketCall);
}

export default function* rootSagas() {
  yield all([fork(initWebsocket)]);
}
